var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCateTextDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_cate_text_dark_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "icon_cate_text_dark_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 14.75,
  y: 6.75,
  rx: 0.4
})), /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 14.75,
  y: 6.75,
  stroke: "#777",
  strokeWidth: 3.2,
  mask: "url(#icon_cate_text_dark_svg__b)",
  rx: 0.4
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.622,
  height: 6.622,
  x: 25.827,
  y: 7.55,
  stroke: "#777",
  strokeWidth: 1.6,
  rx: 3.311
}), /*#__PURE__*/React.createElement("mask", {
  id: "icon_cate_text_dark_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 25.027,
  y: 17.028,
  rx: 0.4
})), /*#__PURE__*/React.createElement("rect", {
  width: 8.222,
  height: 8.222,
  x: 25.027,
  y: 17.028,
  stroke: "#777",
  strokeWidth: 3.2,
  mask: "url(#icon_cate_text_dark_svg__c)",
  rx: 0.4
}), /*#__PURE__*/React.createElement("rect", {
  width: 6.622,
  height: 6.622,
  x: 15.55,
  y: 17.828,
  stroke: "#777",
  strokeWidth: 1.6,
  rx: 3.311
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#777",
  d: "M11.588 31.969c-.01 2.583-.8 4.873-3.994 6.445l-.508-.693c1.582-.777 2.524-1.719 3.042-2.827l-2.857.268-.136-.8 3.281-.22c.132-.45.205-.923.24-1.421H7.593v-.752zm1.338 7.851v-8.74h.928v3.496h1.357v.762h-1.357v4.482zm6.338-7.705v.742H16.88v1.612h1.992v.722h-1.992v1.836c1.142-.014 1.89-.058 2.793-.224l.078.752c-1.006.205-1.836.22-3.193.224h-.567v-5.664zm.068 2.998v-.752h1.182v-3.095h.879v8.125h-.88v-4.278zm2.969 4.717v-8.75h.898v8.75zm9.101-7.91v.86c-.005 1.078-.005 2.29-.332 4.081l-.937-.097c.337-1.695.337-2.935.342-3.985v-.107h-5.313v-.752zm-7.08 6.728v-.771h3.037v-3.086h.918v3.086h4.024v.771zm15.909-7.568v8.77h-.928v-8.77zm-6.778 1.543v-.752h4.102v3.194H34.41v1.913c1.421-.004 2.656-.073 4.121-.312l.088.762c-1.548.259-2.866.317-4.414.322h-.742v-3.428h3.144v-1.699z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_cate_text_dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 3h26v26H11z"
})))));
export default SvgIconCateTextDark;